import "./Inicio.css"
const Inicio = () =>{
return(
    <>
    <h1>Inicio</h1>
    <section>
        <article>
            <h3>El Prólogo</h3>
            <h4>Tema de Ciencia Ficcion</h4>
            <p>Futuro anticipado: se especula acerca del futuro que le espera a la raza humana (utópico o distópico);
y viajes por el espacio: que puede comprender la conquista de mundos alejados en el espacio exterior.</p>
</article>
<article>
            <h4>Situacion Inicial</h4>
            <p>El protagonista, que está terminando una excursión, va a una colina a descanzar. Allí se encuentra con el Hombre Ilustrado. Este le pide si puede descansar con él, y nuestro protagonista acepta. </p>
        </article>
        <article>
            <h4>Desarrollo</h4>
            <p>El desarrollo comienza cuando el hombre ilustrado cuenta su historia a nuestro protagonista. Le relata sobre la bruja y sus ilustraciones, las cuales representan historias, que se desarrollan y toman vida.</p>
        </article>
        <article>
            <h4>Situacion Final</h4>
            <p>Teniendo al hombre ilustrado de espaldas, el protagonista se queda observando la primera ilustración, que se anima y empieza a relatar su historia, llevándonos al primer cuento: La Pradera.</p>
        </article>
    </section>
    </>
)
}
export default Inicio